import { JsonLd } from './JsonLd';
import { SITE_URL, ORG_NAME } from './constants';

/**
 * Product + Offer JSON-LD for the $129 "until you pass" full-access offer.
 * One-time purchase — deliberately NO priceSpecification/billing period so the
 * markup never implies a recurring charge.
 */
export function buildProductOfferSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'SWTPA Full Access: ASWB Exam Prep',
    description:
      'One-time purchase of complete access to Social Work Test Prep Academy: adaptive practice, full question bank, and analytics. Pay once and study until you pass. You are never billed again.',
    brand: {
      '@type': 'Brand',
      name: ORG_NAME,
    },
    category: 'Test preparation',
    offers: {
      '@type': 'Offer',
      price: '129',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      url: `${SITE_URL}/pricing`,
    },
  };
}

export function ProductOfferSchema() {
  return <JsonLd data={buildProductOfferSchema()} />;
}
